function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { colors } from "../theme/colors";
import { defaultTheme } from "../theme/theme";
var materialUITheme = createTheme({
  palette: _objectSpread({
    primary: {
      main: colors.blue['500']
    }
  }, colors),
  typography: {
    fontFamily: defaultTheme.fonts.body,
    body1: {
      fontSize: '14px'
    }
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: colors.red['500'],
        '&$error': {
          color: colors.red['500']
        }
      }
    },
    MuiInputBase: {
      formControl: {
        'label + &': {
          marginTop: '0px !important'
        }
      }
    }
  }
});
export var MaterialUIThemeProvider = function MaterialUIThemeProvider(props) {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: materialUITheme
  }, props.children);
};